module.exports = __webpack_public_path__ + "static/media/crater.2ace9100.svg";